import { gql } from '@apollo/client';

export const GET_IMAGES = gql`
  query getImages($input: FileInput!) {
    getImages(input: $input) {
      id
      key
      url
      name
      title
      description
      link_to
    }
  }
`;

export const GET_IMAGE = gql`
  query getImage($input: String) {
    getImage(input: $input) {
      id
      key
      url
      name
      title
      description
      link_to
    }
  }
`;
